import {
  Spacer_default
} from "./chunk-SM5USSXF.mjs";
import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// components/Spacer/index.ts
init_react_import();
var Spacer_default2 = Spacer_default;

export {
  Spacer_default2 as Spacer_default
};
//# sourceMappingURL=chunk-TFAZJAPA.mjs.map